module.exports = __webpack_public_path__ + "img/icon_map_0_off.ca94c695.png";